export default "/fcbcac1db17390110677298f9d30eeed9c121039/c5d6534f4f2cb925009575e748220704.svg";